import { BnFormErrorMessage } from '@bndes/bndes-ux4/bn-form-validation';

export const msgErroClientSide = 'O servidor do sistema não está acessível no momento.';
export const msgErroUrlRest = 'Serviço REST não existe. Abra um incidente informando a URL:';

export const valor12digitos2decimais: RegExp = /^\d{1,12}([\.\,]\d{1,2})?$/;
export const valor11digitos: RegExp = /^\d{1,11}$/;
export const valor2digitos: RegExp = /^\d{1,2}$/;
export const valor14digitos: RegExp = /^\d{1,14}$/;

export const msgErroValorObrigatorio = 'É obrigatório informar um valor (válido).';
export const msgErroValorInvalido =
    'O valor deve ser um número maior ou igual a zero, ' +
    'com no máximo 2 casas decimais e e no máximo 12 casas na parte inteira, sem separador de milhar.';

export const BN_MUST_NOT_MATCH: BnFormErrorMessage[] = [
  {
    error: 'mustNotMatch',
    format: label => `Campos não podem ser iguais`
  }];


